import _typeof from "@babel/runtime/helpers/esm/typeof";
import "antd/es/col/style";
import _Col from "antd/es/col";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "antd/es/row/style";
import _Row from "antd/es/row";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "Wrapper"],
    _excluded2 = ["children", "Wrapper"];
import React from "react";
import { useContext, useMemo } from 'react';
import FieldContext from '../FieldContext';
export var gridHelpers = function gridHelpers(_ref) {
  var grid = _ref.grid,
      rowProps = _ref.rowProps,
      colProps = _ref.colProps;
  return {
    grid: !!grid,
    RowWrapper: function RowWrapper() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          children = _ref2.children,
          Wrapper = _ref2.Wrapper,
          props = _objectWithoutProperties(_ref2, _excluded);

      if (!grid) {
        return Wrapper ? /*#__PURE__*/React.createElement(Wrapper, null, children) : children;
      }

      return /*#__PURE__*/React.createElement(_Row, _extends({
        gutter: 8
      }, rowProps, props), children);
    },
    ColWrapper: function ColWrapper() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          children = _ref3.children,
          Wrapper = _ref3.Wrapper,
          rest = _objectWithoutProperties(_ref3, _excluded2);

      var props = useMemo(function () {
        var originProps = _objectSpread(_objectSpread({}, colProps), rest);
        /**
         * `xs` takes precedence over `span`
         * avoid `span` doesn't work
         */


        if (typeof originProps.span === 'undefined' && typeof originProps.xs === 'undefined') {
          originProps.xs = 24;
        }

        return originProps;
      }, [rest]);

      if (!grid) {
        return Wrapper ? /*#__PURE__*/React.createElement(Wrapper, null, children) : children;
      }

      return /*#__PURE__*/React.createElement(_Col, props, children);
    }
  };
};
export var useGridHelpers = function useGridHelpers(props) {
  var config = useMemo(function () {
    {
      if (_typeof(props) === 'object') {
        return props;
      }

      return {
        grid: props
      };
    }
  }, [props]);

  var _useContext = useContext(FieldContext),
      grid = _useContext.grid;

  return useMemo(function () {
    return gridHelpers({
      grid: !!(grid || config.grid),
      rowProps: config === null || config === void 0 ? void 0 : config.rowProps,
      colProps: config === null || config === void 0 ? void 0 : config.colProps,
      Wrapper: config === null || config === void 0 ? void 0 : config.Wrapper
    });
  }, [config === null || config === void 0 ? void 0 : config.Wrapper, config === null || config === void 0 ? void 0 : config.colProps, config.grid, config === null || config === void 0 ? void 0 : config.rowProps, grid]);
};